<template>
    <div>
        <h4 class="section-title">
            {{ $t("supplierDetail.nav.payments") }}
        </h4>

        <EmptySection v-show="!hasPaymentsData" :message="$t('supplierDetail.payments.nodata')"></EmptySection>
        <InvoiceDetailTable
            v-show="hasPaymentsData"
            :table-settings="paymentsTableConfig"
            :debounce="filterDebounce"
            :sort-options="paymentsSortOptions"
            :hash="hash"
            :version="version"
            :type="type"
            :typeId="typeId"
            ref="payments_data_table"
        >
            <template v-slot:data_date="row">
                {{ row.item.date }}
            </template>

            <template v-slot:data_price_vat="row">{{ formatNumber(row.item.price_vat)}}</template>

            <template v-slot:data_details="row">
                <div v-if="row.item.tender && type == 'supplier'" :class="{'mb-1': hasAnyInfo(row.item)}">
                    <router-link
                        :to="{ name: 'tender-detail', params: { version: version, hash: hash, slug: row.item.tender.slug}}"
                        v-if="type=='supplier'">
                        {{ row.item.tender.title }}
                    </router-link>
                    <span v-else>
                        <b>{{ row.item.tender.title }}</b>
                    </span>
                </div>
                <div v-else-if="row.item.note" :class="{'mb-1': hasAnyInfo(row.item)}">
                    <b>{{ row.item.note }}</b>
                </div>

                <PaymentDetailRow v-if="row.item.accounting_number && row.item.src !== 'pap'">
                    <template v-slot:header>
                        {{ $t("supplierDetail.payments.table.head.accounting_number") }}
                    </template>
                    <template v-slot:content>
                        {{ row.item.accounting_number }}
                    </template>
                </PaymentDetailRow>

                <PaymentDetailRow v-if="row.item.accounting_name">
                    <template v-slot:header>
                        {{ $t("supplierDetail.payments.table.head.accounting_name") }}
                    </template>
                    <template v-slot:content>
                        {{ row.item.accounting_name }}
                    </template>
                </PaymentDetailRow>

                <PaymentDetailRow v-if="row.item.budget_unit_number">
                    <template v-slot:header>
                        {{ $t("supplierDetail.payments.table.head.budget_unit_number") }}
                    </template>
                    <template v-slot:content>
                        {{ row.item.budget_unit_number }}
                    </template>
                </PaymentDetailRow>

                <PaymentDetailRow v-if="row.item.budget_unit_name">
                    <template v-slot:header>
                        {{ $t("supplierDetail.payments.table.head.budget_unit_name") }}
                    </template>
                    <template v-slot:content>
                        {{ row.item.budget_unit_name }}
                    </template>
                </PaymentDetailRow>

                <PaymentDetailRow v-if="row.item.budget_paragraph_number">
                    <template v-slot:header>
                        {{ $t("supplierDetail.payments.table.head.budget_paragraph_number") }}
                    </template>
                    <template v-slot:content>
                        {{ row.item.budget_paragraph_number }}
                    </template>
                </PaymentDetailRow>

                <PaymentDetailRow v-if="row.item.budget_paragraph_name">
                    <template v-slot:header>
                        {{ $t("supplierDetail.payments.table.head.budget_paragraph_name") }}
                    </template>
                    <template v-slot:content>
                        {{ row.item.budget_paragraph_name }}
                    </template>
                </PaymentDetailRow>

                <PaymentDetailRow v-if="row.item.department">
                    <template v-slot:header>
                        {{ $t("supplierDetail.payments.table.head.department") }}
                    </template>
                    <template v-slot:content>
                        {{ row.item.department }}
                    </template>
                </PaymentDetailRow>

                <PaymentDetailRow v-if="row.item.person">
                    <template v-slot:header>
                        {{ $t("supplierDetail.payments.table.head.person") }}
                    </template>
                    <template v-slot:content>
                        {{ row.item.person }}
                    </template>
                </PaymentDetailRow>

                <PaymentDetailRow v-if="row.item.note2">
                    <template v-slot:header>
                        {{ $t("supplierDetail.payments.table.head.note2") }}
                    </template>
                    <template v-slot:content>
                        {{ row.item.note2 }}
                    </template>
                </PaymentDetailRow>
            </template>
        </InvoiceDetailTable>
    </div>
</template>

<script>
import formattersMixin from "@/plugins/formattersMixin.js";
import PaymentDetailRow from "@/components/PaymentDetailRow.vue";
import EmptySection from "@/components/EmptySection.vue";
import InvoiceDetailTable from "@/components/InvoiceDetailTable.vue";
import dataTableMixin from "@/plugins/dataTableMixin.js";
import tableSettingsMixin from "@/plugins/tableSettingsMixin.js";

export default {
    props: {
        version: { required: true },
        hash: { required: true },
        type: { required: true },
        typeId: { required: true },
        externalData: { required: true }
    },
    name: "invoice-table",
    components: {
        PaymentDetailRow,
        EmptySection,
        InvoiceDetailTable
    },
    mixins: [formattersMixin, dataTableMixin, tableSettingsMixin],
    data: function() {
        return {
            data: null
        };
    },
    computed: {
        hasPaymentsData: function() {
            return this.externalData.invoices_count > 0;
        },
        hasPaymentsAddData: function() {
            return this.externalData.invoices_count_add_info > 0;
        },
        paymentsTableConfig: function() {
            var settings ={}
            if (this.hasPaymentsAddData) {
                settings = this.paymentsTableSettingsAddInfo;
                if (this.externalData.tenders_links_count==0  && this.externalData.invoice_notes_count == 0){
                    settings.fields.splice(1,1);
                }
                return settings;
            } else {
                settings = this.paymentsTableSettings;
                if (this.externalData.tenders_links_count==0 && this.externalData.invoice_notes_count == 0){
                    settings.fields.splice(1,1);
                }
                return settings;
            }
        },
        filterDebounce: () => 700
    },
    methods: {
        paymentsTableDataProvider: function(ctx) {
            var params = this.initRequestParams(ctx);
            if (!ctx.filter) {
                ctx.filter = {};
            }
            params[this.type] = this.typeId;
            params[`${this.version}_hash`] = this.hash;
            params["q"] = ctx.filter.q;
            params["years"] = JSON.stringify(ctx.filter.years);

            return this.$store.getters.api
                .get("invoice/", { params: params })
                .then((response) => {
                    var data = response.data.data;
                    data.forEach((n) => {
                        var hasMetaInfo = [n.accounting_number, n.budget_paragraph_name, n.budget_unit_name, n.department, n.person].some(
                            (n) => n !== null && n !== undefined
                        );
                        n["has_meta"] = hasMetaInfo;

                        if (hasMetaInfo || !!n.note) {
                            n["_showDetails"] = true;
                        }
                    });

                    this.$refs.payments_data_table.setTotalRows(response.data.count);

                    return data;
                })
                .catch((e) => {
                    console.dir(e);
                    return [];
                });
        },
        hasAnyInfo: function(payment){
            var allowedInfos = ["note2", "person", "department", "budget_paragraph_name", "budget_paragraph_number", "budget_unit_name",
                "budget_unit_number", "accounting_name"]
            for (const key in payment) {
                if(allowedInfos.includes(key) && payment[key]){
                    return true
                }
            }
            if (payment["accounting_number"] && payment["src"] !== 'pap'){
                return true
            }
            return false
        },
    }
};
</script>